import React from 'react'
import { Link, useLocation } from 'react-router-dom'

function PaymentSuccess() {
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const message = params.get('message') || params.get('statusMessage') || params.get('description') || params.get('msg') || ''
  const transactionId = params.get('txnid') || params.get('transactionId') || params.get('paymentId') || ''
  const amount = params.get('amount') || ''
  const orderId = params.get('orderId') || params.get('merchantOrderId') || params.get('order_id') || ''
  const rawStatus = params.get('status') || params.get('paymentStatus') || params.get('statuscode') || params.get('txStatus') || params.get('respCode') || ''

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      background: 'linear-gradient(180deg, #effaf4 0%, #ffffff 100%)',
      fontFamily: 'Inter, system-ui, sans-serif'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '640px',
        borderRadius: '24px',
        overflow: 'hidden',
        boxShadow: '0 30px 80px rgba(15, 23, 42, 0.12)'
      }}>
        <div style={{
          padding: '34px 30px',
          background: 'linear-gradient(135deg, #16a34a 0%, #22c55e 100%)',
          color: '#ffffff'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '18px' }}>
            <div style={{
              width: '70px',
              height: '70px',
              borderRadius: '50%',
              display: 'grid',
              placeItems: 'center',
              background: 'rgba(255,255,255,0.18)',
              fontSize: '34px',
              fontWeight: 700
            }}>
              ✓
            </div>
            <div>
              <h1 style={{ margin: 0, fontSize: '30px', lineHeight: 1.1 }}>Payment Successful</h1>
              <p style={{ margin: '10px 0 0', fontSize: '15px', color: 'rgba(255,255,255,0.88)' }}>
                Your payment has been completed successfully.
              </p>
            </div>
          </div>
        </div>

        <div style={{ background: '#ffffff', padding: '28px 30px' }}>
          <div style={{ display: 'grid', gap: '20px' }}>
            <div style={{
              padding: '20px',
              borderRadius: '18px',
              background: '#f0fdf4',
              border: '1px solid #d9f7e5'
            }}>
              <h2 style={{ margin: 0, fontSize: '17px', color: '#065f46' }}>Payment summary</h2>
              <p style={{ margin: '10px 0 0', color: '#0f766e', fontSize: '14px', lineHeight: 1.7 }}>
                {message || 'We have received your payment. Thank you for your order.'}
              </p>
            </div>

            <div style={{ display: 'grid', gap: '14px' }}>
              {transactionId && (
                <div style={{ padding: '18px 20px', borderRadius: '16px', background: '#f8faf9', border: '1px solid #e2f6ea' }}>
                  <strong style={{ display: 'block', marginBottom: '6px', color: '#0f766e' }}>Transaction ID</strong>
                  <span style={{ color: '#134e4a' }}>{transactionId}</span>
                </div>
              )}
              {orderId && (
                <div style={{ padding: '18px 20px', borderRadius: '16px', background: '#f8faf9', border: '1px solid #e2f6ea' }}>
                  <strong style={{ display: 'block', marginBottom: '6px', color: '#0f766e' }}>Order ID</strong>
                  <span style={{ color: '#134e4a' }}>{orderId}</span>
                </div>
              )}
              {amount && (
                <div style={{ padding: '18px 20px', borderRadius: '16px', background: '#f8faf9', border: '1px solid #e2f6ea' }}>
                  <strong style={{ display: 'block', marginBottom: '6px', color: '#0f766e' }}>Amount</strong>
                  <span style={{ color: '#134e4a' }}>₹ {amount}</span>
                </div>
              )}
              {rawStatus && (
                <div style={{ padding: '18px 20px', borderRadius: '16px', background: '#f8faf9', border: '1px solid #e2f6ea' }}>
                  <strong style={{ display: 'block', marginBottom: '6px', color: '#0f766e' }}>Status code</strong>
                  <span style={{ color: '#134e4a' }}>{rawStatus}</span>
                </div>
              )}
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '14px', marginTop: '8px' }}>
              <Link to="/phonepe-pay" style={{
                flex: '1 1 180px',
                minWidth: '150px',
                padding: '14px 18px',
                borderRadius: '999px',
                background: '#16a34a',
                color: '#fff',
                textDecoration: 'none',
                fontWeight: 700,
                textAlign: 'center'
              }}>
                Pay again
              </Link>
              <a href="/" style={{
                flex: '1 1 180px',
                minWidth: '150px',
                padding: '14px 18px',
                borderRadius: '999px',
                background: '#f1fdf5',
                color: '#047857',
                textDecoration: 'none',
                fontWeight: 700,
                textAlign: 'center',
                border: '1px solid #d1fae5'
              }}>
                Go to homepage
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentSuccess
